import React, { useEffect, useState } from 'react';
import ReactWebChat from 'botframework-webchat';
import useWebChat from '../../Hooks/useWebChat';

import ChatbotLayout from '../../UiKit/Chatbot/ChatbotLayout/ChatbotLayout';
import Header from '../../UiKit/Chatbot/Header/Header';
import Footer from '../../UiKit/Chatbot/Footer/Footer';
import WebchatMenu from './WebchatMenu/WebchatMenu';
import useChatbot from '../../Hooks/useChatbot';
import activityMiddleware from './ActivityMiddleware';
import WelcomeScreen from './WelcomeScreen/WelcomeScreen';
import attachmentMiddleware from './AttachmentMiddleware';
import useLanguageHook from '../../Hooks/useLanguageHook';
import useLiveChatEvents from '../../Hooks/useLiveChatEvents';
import NavigationButton from '../../UiKit/Wizard/NavigationButton/NavigationButton'; 
import CloseModal from '../Webchat/LiveChat/live-chat-card/CloseModal';
import translation from '../../Components/Webchat/LiveChat/translation';


function Webchat() {
  const {
    directline,
    store,
    initializeWebchat,
    resetWebchat,
    isInitialized,
    styleOptions,
    locale,
    sendMessage,
    sendActivityUsingDirectlineObject
  } = useWebChat();

  const [showCloseModal, setShowCloseModal] = useState(false);


  const {
    hasBeenOpened,
    showWelcomeScreen,
    setShowWelcomScreen,
    autoOpenUtterance,
    isLiveChatActive,
    //endLiveChat,
    setIsLiveChatActive
  } = useChatbot();

  const { currentLanguage, didLanguageSwitch } = useLanguageHook();
  const liveChatButtonTranslations = translation[currentLanguage]["button"];

  useLiveChatEvents();

  useEffect(() => {
    if (hasBeenOpened && !isInitialized()) {
      initializeWebchat();
    }
  }, [hasBeenOpened, isInitialized()]);

  useEffect(() => {
    if (didLanguageSwitch()) {
      setShowWelcomScreen(true);
      resetWebchat();
    }
  }, [currentLanguage]);

  useEffect(() => {
    if (store && autoOpenUtterance) {
      setTimeout(() => {
        sendMessage(autoOpenUtterance);
      }, 500);
    }
  }, [store]);

  useEffect(() => {
    if (!directline || !directline.activity$) return;

    const subscription = directline.activity$.subscribe((activity) => {
      if (activity.type === 'event') {
        if (activity.name === 'liveChatStarted') {
          //console.log("✅ Setting live chat active");
          setIsLiveChatActive(true);
        }
        if (activity.name === 'closeLiveChat') {
          //console.log("Ending live chat");
          setIsLiveChatActive(false);
        }
      }    
    
    });

    return () => subscription.unsubscribe();
  }, [directline, setIsLiveChatActive]);

const endLiveChat = () => {
  //console.log(" Ending live chat");

  if (directline) {
    sendActivityUsingDirectlineObject(directline, {
      type: 'event',
      name: 'closeLiveChat',
      from: { id: 'user1', name: 'User' },
      value: { reason: 'userInitiated' }
    });
  }
  

  setIsLiveChatActive(false);
};



  return (
    <ChatbotLayout>
      <ChatbotLayout.Header>
        <Header />
        <WebchatMenu />
      </ChatbotLayout.Header>

      <ChatbotLayout.Webchat>
        {directline && store ? (
          <div style={{ position: 'relative', height: '100%' }}>
            {showWelcomeScreen && <WelcomeScreen />}

            {isLiveChatActive && (
              <div className="livechat-end-button-container">
                <NavigationButton
                  type="primary"
                  style={{
                    fontSize: '16px',
                    padding: '12px 24px',
                    width: '100%',
                    height: '100%',
                    width: '322px',
                    height: '43px',
                    padding: '12px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '12px',
                    position: 'absolute',
                    left: '19px',
                    top: '8px',
                  }}
                  // onClick={endLiveChat}
                  onClick={() => setShowCloseModal(true)}
                >
                  {liveChatButtonTranslations.endLiveChat}
                </NavigationButton>
              </div>
            )}

            <ReactWebChat
              directLine={directline}
              store={store}
              activityMiddleware={activityMiddleware}
              attachmentMiddleware={attachmentMiddleware}
              styleOptions={styleOptions}
              locale={locale}
            />
            {showCloseModal && (
  <CloseModal
    type="endLiveChat"
    onConfirm={() => {
      if (directline) {
        // sendActivityUsingDirectlineObject(directline, {
        //   type: 'event',
        //   name: 'closeLiveChat',
        //   from: { id: 'user1', name: 'User' },
        //   value: { reason: 'userInitiated' }
        // });
        sendActivityUsingDirectlineObject(directline, {
          type: 'event',
          name: 'closeLiveChat',
          from: { id: 'user1', name: 'User' },
          value: {
            reason: 'userInitiated',
            lang: locale 
          }
        });
        
      }

      setIsLiveChatActive(false);
      setShowCloseModal(false);
    }}
    onCancel={() => {
      setShowCloseModal(false);
    }}
  />
)}

          </div>
        ) : null}
      </ChatbotLayout.Webchat>

      <ChatbotLayout.Footer>
        <Footer isHomeScreen={showWelcomeScreen} />
      </ChatbotLayout.Footer>
    </ChatbotLayout>
  );
}

export default Webchat;
